module.exports = __webpack_public_path__ + "img/icon_控费@2x.d13f4b47.png";